const getUnchangedTrip = (canExchange, trips, pastJourneyElementTrips) => {
  if (!canExchange || !pastJourneyElementTrips.length) return null;

  const isPartialExchange = pastJourneyElementTrips.length > trips.length;

  if (!isPartialExchange) return null;

  const isFirstTripChanged = pastJourneyElementTrips[0]?.originCode === trips[0]?.originCode;

  const unchangedTrip = isFirstTripChanged
    ? pastJourneyElementTrips[1]
    : pastJourneyElementTrips[0];

  if (!unchangedTrip) return null;

  return {
    ...unchangedTrip,
    arrivalTime: unchangedTrip.startsAtInUserTz,
    departureTime: unchangedTrip.endsAtInUserTz,
    marketingAirlineLogos: unchangedTrip.segments.map(
      ({ marketingAirlineInfo }) => marketingAirlineInfo.code,
    ),
    marketingAirlineCodes: unchangedTrip.segments.map(({ operatingFlight }) => operatingFlight),
    tripDurationInMinutes: unchangedTrip.durationInMinutes,
  };
};

export default getUnchangedTrip;
